module.exports = __webpack_public_path__ + "static/media/gas-station.0ac155ba.svg";